// extracted by mini-css-extract-plugin
export default {"main":"MainBlock_main__7f7SM","main_wrap":"MainBlock_main_wrap__wql-U","main_title":"MainBlock_main_title__F1Yay","main_desc":"MainBlock_main_desc__Eh64X"};